import { makeStyles } from 'tss-react/mui';
import { useMainParticipant, useParticipants, useVideoContext, useScreenShareParticipant } from '../hooks';
import { Participant } from './participant';

const useStyles = makeStyles()({
  container: {
    overflowY: 'auto',
    background: 'rgb(79, 83, 85)',
    gridArea: '1 / 2 / 1 / 3',
    top: '0',
    right: '0',
    position: 'absolute',
    zIndex: 99,
    width: '150px',
    scroll: 'none',
  },
  transparentBackground: {
    background: 'transparent',
  },
});

export function ParticipantList() {
  const { classes, cx } = useStyles();
  const { room } = useVideoContext();
  const localParticipant = room?.localParticipant;
  const participants = useParticipants();

  const screenShareParticipant = useScreenShareParticipant();
  const isRemoteParticipantScreenSharing = screenShareParticipant && screenShareParticipant !== localParticipant;


  // const [selectedParticipant, setSelectedParticipant] = useSelectedParticipant();
  const mainParticipant = useMainParticipant();

  if (participants.length === 0 || !localParticipant) return null; // Don't render this component if there are no remote participants.

  return (
    <aside
      className={cx(classes.container, {
        [classes.transparentBackground]: !isRemoteParticipantScreenSharing,
      })}
    >
      <Participant participant={localParticipant} isLocalParticipant={true} />
      {participants.map(participant => {
        //  const isSelected = participant === selectedParticipant;
        const hideParticipant =
          participant === mainParticipant && participant !== screenShareParticipant;
        //  && !isSelected;

        return (
          <Participant
            key={participant.sid}
            participant={participant}
            // isSelected={participant === selectedParticipant}
            hideParticipant={hideParticipant}
          />
        );
      })}
    </aside>
  );
}
